import { render, staticRenderFns } from "./LimitButtonsGroup.vue?vue&type=template&id=cb065274&scoped=true&"
import script from "./LimitButtonsGroup.vue?vue&type=script&lang=js&"
export * from "./LimitButtonsGroup.vue?vue&type=script&lang=js&"
import style0 from "./LimitButtonsGroup.vue?vue&type=style&index=0&id=cb065274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb065274",
  null
  
)

export default component.exports